import { getMetricEventByEventKeyAndDataSourceQuery } from '@gonfalon/rest-api/queries/metricEvents';
import { useSuspenseQuery } from '@tanstack/react-query';

export const useSuspenseEventActivityByEventKey = (
  projectKey: string,
  eventKey: string,
  eventKind: string,
  dataSourceKey: string,
) =>
  useSuspenseQuery(
    getMetricEventByEventKeyAndDataSourceQuery({
      projKey: projectKey,
      eventKind,
      dataSourceKey,
      eventKey,
    }),
  );
